import { FC } from "react";
import ResponsiveSheet from "@Components/ResponsiveSheet/ResponsiveSheet";
import { useHotelDynamicDetails } from "../../context";
import ProfileIcon from "@Icons/MainIcons/ProfileIcon";
import { useTranslation } from "react-i18next";
import GuestSummaryTrigger from "./components/GuestSummaryTrigger/GuestSummaryTrigger";
import GuestSummaryContent from "./components/GuestSummaryContent/GuestSummaryContent";

const GuestSummaryTitle: FC<{ numRooms: number; numGuests: number }> = ({ numRooms, numGuests }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2">
      <div className="text-background-primary-active bg-background-subtle flex h-10 w-10 items-center justify-center rounded-sm">
        <ProfileIcon className="w-7 h-7"/>
      </div>
      <div className="flex flex-col">
        <div className="text-font-default text-base font-semibold">{t("Hotels.guests.guestDetails")}</div>
        <div className="text-font-subtle text-xs">
          {numGuests === 1 ? t("Hotels.common.oneGuest") : t("Hotels.common.guestsCount", { count: numGuests })}
          {" · "}
          {numRooms === 1 ? t("Hotels.booking.oneRoom") : t("Hotels.booking.roomsCount", { count: numRooms })}
        </div>
      </div>
    </div>
  );
};

export default function GuestSummaryCard() {
  const { guestsState } = useHotelDynamicDetails();
  const [guests] = guestsState;

  const guestItems = Object.values(guests)
    .filter((g) => g.firstName || g.lastName)
    .map((g) => ({
      title: [g.title, g.firstName, g.lastName]
        .filter(Boolean)
        .map((s) => s!.charAt(0).toUpperCase() + s!.slice(1).toLowerCase())
        .join(" "),
      imgUrl: "",
    }));

  const entries = Object.entries(guests).filter(([, g]) => g.firstName || g.lastName);
  const numRooms = new Set(entries.map(([key]) => key.match(/^room_(\d+)/)?.[1])).size;
  const numGuests = entries.length;

  if (guestItems.length === 0) return null;

  return (
    <ResponsiveSheet
      label={<GuestSummaryTitle numRooms={numRooms} numGuests={numGuests} />}
      renderTrigger={({ open }) => <GuestSummaryTrigger guestItems={guestItems} onClick={open} />}
      renderSheet={() => <GuestSummaryContent />}
    />
  );
}
